export const SET_TOKEN = 'setToken';
export const SET_PROFILE = 'setProfile';
export const LOGOFF = 'logoff';
export const CLEAR_STORAGE = 'clearStorage';
export const SET_LOGIN_ERROR = 'setLoginError';
export const CLEAR_LOGIN_ERROR = 'clearLoginError';
export const SESSION_OFF = 'sessionOff';
